import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiserviceService } from '../apiservice.service';


@Component({
  selector: 'app-moviedetails',
  templateUrl: './moviedetails.component.html',
  styleUrls: ['./moviedetails.component.scss']
})

export class MoviedetailsComponent implements OnInit {



coverPrefix:string="https://image.tmdb.org/t/p/original/"
imgPrefix:string="https://image.tmdb.org/t/p/w500";
movieId:any=527774



youtubeKey:any;
url:any;



moviesDetails:any ={}
details:any;


cast:any[]=[];





  constructor(private _ActivatedRoute:ActivatedRoute ,private  _ApiserviceService:ApiserviceService) {

    this.movieId=this._ActivatedRoute.snapshot.paramMap.get("id")


  // Details

      this.details=_ApiserviceService.getMovieDetails(this.movieId).subscribe((data)=>{

      this.moviesDetails= data
      
      })



//youtube link

      this._ApiserviceService.getYoutubeLink(this.movieId).subscribe((data)=>{
      this.youtubeKey=data.results[0].key

      this.url="https://www.youtube.com/embed/"+this.youtubeKey



//Cast 
      
        this._ApiserviceService.getMovieCast(this.movieId).subscribe((data)=>{

          this.cast=data.cast.slice(0, 6)
        

        })
    })
   }

  ngOnInit(): void {
  }

}
